import { userEndPoints } from "../config";
import CommonService from "./CommonService";
class userService {
  async userLogin(email, password) {
    return CommonService.post(userEndPoints.login, {
      email: email,
      password: password,
    });
  }

  async getUserProfile(data) {
    return CommonService.get(userEndPoints.userprofile);
  }
  async userChat(data) {
    return CommonService.post(userEndPoints.chat, {
      input_text: data,
    });
  }
  async userPdfUpload(data) {
    const formData = new FormData();
    formData.append("file", data);
    return CommonService.post(userEndPoints.pdfUpload, {
      formData,
    });
  }
  async userAskQuestion(data) {
    return CommonService.post(userEndPoints.askQuestion, {
      input_text: data,
    });
  }
  async summarizeLink(data) {
    return CommonService.post(userEndPoints.linkSummarize, {
      input_text: data,
    });
  }
  async generateTatImage(data) {
    return CommonService.get(userEndPoints.generateImage + `?category=${data}`);
  }
  async generateWatWords() {
    return CommonService.get(userEndPoints.generateWatWords);
  }
  async generateSRT() {
    return CommonService.get(userEndPoints.generateSRT);
  }

  async generateSrt() {
    return CommonService.get(userEndPoints.getSrt);
  }

  async updatePIQ(data) {
    return CommonService.post(userEndPoints.updatePIQ, {
      fullName: data?.fullName,
      address: data?.address,
      familiyIncome: data?.familiyIncome,
      height: data?.height,
      weight: data?.weight,
      SSBRecord: data?.SSBRecord,
      hobbyAndInterest: data?.hobbies,
      sports: data?.sports,
      qualifications: data?.qualifications,
    });
  }

  async myPIQ() {
    return CommonService.get(userEndPoints.myPIQ);
  }


  async createNewCurrentAffairs(data) {
    return CommonService.post(userEndPoints.createCurrentAffair, data);
  }
  
  async updateCurrentAffairs(data,id) {
    return CommonService.put(userEndPoints.editCurrentAffair + id, data);
  }
  async getAllCurrentAffair() {
    return CommonService.get(userEndPoints?.getCurrentAffairList);
  }
  async getCurrentAffairByDate(date) {
    const data = CommonService.get(userEndPoints?.getCurrentAffairDate + date);
    return data?.response
  }
}
const userServiceInstance = new userService();

export default userServiceInstance;;
